import axios from 'axios'

export default new class SystemService {
  export (data) {
    return axios.post('/system/export',data)
  }

  import (data) {
    return axios.post('/system/import',data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}()
